import styled from '@emotion/styled';

import { pageSectionLayout } from '@/styles/pageLayout';

export const MapContainer = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 6rem;
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	@media screen and (max-width: 900px) {
		& > * {
			padding: 0 2rem;
		}
		& > :last-child {
			padding: 0 0rem;
		}
	}
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const MapsContent = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const MapsContentSubContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.8rem;
	@media screen and (max-width: 900px) {
		display: flex;
		flex-direction: column;
		gap: 0.4rem;
	}
`;
export const ImgMapBox = styled.div`
	height: 40rem;
`;

export const MapPlaceholder = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 400px;
	border-radius: ${({ theme }) => theme.effects.radiusMd};
	background: ${({ theme }) => theme.ui.surface.subtle};
	border: 1px solid ${({ theme }) => theme.ui.border.default};
	color: ${({ theme }) => theme.ui.text.secondary};
	font-size: ${({ theme }) => theme.fontSize.sizeMd};
	text-align: center;
	padding: 2rem;
`;
export const MapBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	width: 100%;
	padding: 2rem;
	background-color: #f1f3f5;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const MapContent = styled.div`
	display: flex;
	flex-direction: column;
	padding-bottom: 2rem;
	border-bottom: 1px solid #dee2e6;
	gap: 0.8rem;
	:last-child {
		padding-bottom: 0;
		border-bottom: none;
	}
	.menu_box {
		display: flex;
		align-items: center;
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
		border-radius: 999.9rem;
		padding: 0.4rem 1.2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: ${(props) => props.theme.ui.lineHeight.heading};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		width: fit-content;
	}
	.menu_box_list {
	}
`;
